import React, { useState } from 'react';
import { useTheme } from '../theme/ThemeContext';

const UserLegend = ({ userPointsData, scatterplot, basePoints, scatterColorCategory, setUserColorMode }) => {
    const { theme } = useTheme();
    const [colorMode, setColorMode] = useState('sample'); // 'sample' or 'confidence'

    const containerStyle = {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: '20px',
        backgroundColor: theme.colors.overlay,
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        borderRadius: '10px',
        padding: '20px',
        zIndex: 1000,
        maxWidth: '300px',
        fontFamily: 'Arial',
    };

    const buttonStyle = {
        padding: '5px 10px',
        marginBottom: '10px',
        backgroundColor: 'transparent',
        border: `1px solid ${theme.colors.text}`,
        borderRadius: '5px',
        color: theme.colors.text,
        cursor: 'pointer',
        fontSize: '12px',
        marginRight: '5px'
    };

    const activeButtonStyle = {
        ...buttonStyle,
        backgroundColor: theme.colors.primary,
        color: '#fff',
    };

    // Confidence color scale
    // const confidenceColors = [
    //     "#FF0000", "#FF4500", "#FF8C00", "#FFA500", "#FFD700",
    //     "#ADFF2F", "#7FFF00", "#32CD32", "#008000", "#006400"
    // ];
    const confidenceColors = [
        "#440154", "#482878", "#3E4989", "#31688E", "#26828E",
        "#1F9E89", "#35B779", "#6DCD59", "#B4DE2C", "#FDE725"
    ]

    if (!userPointsData || userPointsData.length === 0) {
        return null;
    }

    // Determine which color field to use based on the current mode
    const colorField = colorMode === 'confidence' ? 'confidence_hex' : 'color_hex';

    // Group samples by their colors (only used for sample type mode)
    const colorGroups = {};
    userPointsData.forEach(point => {
        const color = point[colorField] || '#800080';  // Default to purple if missing
        if (!colorGroups[color]) {
            colorGroups[color] = [];
        }
        colorGroups[color].push(point);
    });

    const handleClick = () => {
        if (!scatterplot) return;
        const userSampleIndices = Array.from(
            { length: userPointsData.length },
            (_, i) => i + basePoints.length
        );
        scatterplot.select(userSampleIndices);
    };

    const handleModeChange = (mode) => {
        setColorMode(mode);
        setUserColorMode(mode);
    };

    // Title based on color scheme
    const title = 'User Samples';

    return (
        <div style={containerStyle}>
            <div style={{ marginBottom: '10px', color: theme.colors.text, fontWeight: 'bold' }}>{title}</div>

            <div style={{ display: 'flex', marginBottom: '15px' }}>
                <button
                    style={colorMode === 'sample' ? activeButtonStyle : buttonStyle}
                    onClick={() => handleModeChange('sample')}
                >
                    Sample Type
                </button>
                <button
                    style={colorMode === 'confidence' ? activeButtonStyle : buttonStyle}
                    onClick={() => handleModeChange('confidence')}
                >
                    Confidence
                </button>
            </div>

            {colorMode === 'confidence' ? (

                <div>
                    <div style={{ color: theme.colors.text, marginBottom: '5px' }}>Confidence Scale:</div>
                    <div style={{
                        display: 'flex',
                        width: '100%',
                        height: '20px',
                        marginBottom: '5px',
                        borderRadius: '4px',
                        overflow: 'hidden'
                    }}>
                        {confidenceColors.map((color, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: color,
                                    height: '100%',
                                    width: `${100 / confidenceColors.length}%`
                                }}
                            />
                        ))}
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        color: theme.colors.text,
                        fontSize: '12px',
                        marginBottom: '10px'
                    }}>
                        <span>Low</span>
                        <span>High</span>
                    </div>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={handleClick}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: theme.colors.text
                        }}>
                            {/* Click to select all user samples ({userPointsData.length}) */}
                        </div>
                    </div>
                </div>
            ) : (
                // Sample type color groups display
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={handleClick}
                >
                    {Object.entries(colorGroups).map(([hex, samples], i) => (
                        <div key={hex} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <div
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    backgroundColor: hex,
                                    marginRight: '8px'
                                }}
                            />
                            <span style={{ color: theme.colors.text }}>
                                {`Sample type ${i + 1} (${samples.length})`}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default UserLegend;